import type { Dispatch, AnyAction } from 'redux';

import * as FindJWSWorkRequestIdsAPI from 'ab-api/web/jobWorkSummary/getJWSWorkRequestIds';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function findJWSWorkRequestIds(fieldReportIds: number[]) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const response = await http.get<FindJWSWorkRequestIdsAPI.W_JobWorkSummary_GetJWSWorkRequestIds_VM>(FindJWSWorkRequestIdsAPI.URL(fieldReportIds));
			return response.workRequestIds;
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

